(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Vaccine', Vaccine);

    Vaccine.$inject = ['$resource'];

    function Vaccine ($resource) {
        var resourceUrl =  'api/vaccines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
